import { generateFeatureFlags } from '../_modules/feature_flags/generate_feature_flags';
import { setFlagTo } from '../_modules/feature_flags/set_flag_to';

/**
 * if a store is not defined -> automatically the feature flat is set to false
 * if the feature flag itself if a boolean, it's for all stores
 *
 * e. g:
 *
 * Feature is only enabled for AU and AU_SCA
 * FEATURE_PRICE_RRP: {
 *     AU: true,
 *     AU_SCA: true,
 * }
 *
 * Feature is enabled for all stores
 * FEATURE_FRIEND_BUY: true,
 *
 */
export const featureFlags = generateFeatureFlags({
  FEATURE_FRIEND_BUY: true,
  FEATURE_PRICE_RRP: false,
  FEATURE_SCA_25_PERCENT_DISCOUNT: {
    AU_SCA: false,
    NZ_SCA: false,
  },
  FEATURE_TYRE_DEALS: {
    AU: true,
    AU_SCA: true, // disabled when SCA_25_PERCENT_DISCOUNT is enabled
    AU_NRMA: true,
    NZ: true,
    NZ_SCA: true, // disabled when SCA_25_PERCENT_DISCOUNT is enabled
    ID: true,
    NL: true,
    DE: true,
    AT: true,
    IT: true,
  },
  FEATURE_FSF_FLOW_DISABLED: {
    DE: false,
  },
}, setFlagTo);
